// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--23f1f";
export var core = "Button-module--core--377a5";